module.exports = __webpack_public_path__ + "img/78663788000103.01ca97d2.png";